import ReactDOM from "react-dom/client";
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';

const root = ReactDOM.createRoot(document.getElementById("root"));

const rootElement = document.getElementById("root");
const prerenderHTML = rootElement ? rootElement.innerHTML : "";

// Store it globally so MoRouter can access it
window.__PRERENDER_HTML__ = prerenderHTML;

root.render(<App/>);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
console.log("About to register service worker");
serviceWorker.register();